"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _dropdown = _interopRequireDefault(require("@ux/dropdown"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _text = _interopRequireDefault(require("@ux/text"));
var _core = require("@linaria/core");
const NavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavContainer",
  class: "pl-n10i3z13"
});
const List = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "List",
  class: "pl-l1j4451h"
});
const ListItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "ListItem",
  class: "pl-l1xbtg0y"
});
const anchorStyles = "pl-a1xwchc6";
const DropdownContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DropdownContainer",
  class: "pl-d8dngi5"
});

/**
 * FilterNavItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Id for each item
 * @param {String} props._name Tracking name for each item
 * @param {String} props.text Item text
 * @param {String} props.url Link URL
 * @param {Boolean} props.active Active state
 * @param {String} props.partial Theme partial
 * @returns {React.ReactElement} FilterNavItem Component
 * @public
 */
function FilterNavItem({
  id,
  _name,
  text,
  url,
  active,
  partial = 'actionControlAlt'
}) {
  if (!text) return null;
  return /*#__PURE__*/_react.default.createElement(ListItem, {
    "data-cy": "filter-nav-item",
    "data-partial": partial
  }, /*#__PURE__*/_react.default.createElement(_text.default.a, (0, _extends2.default)({
    id: `id-${id}`,
    as: "title",
    href: url,
    "aria-label": text,
    className: (0, _core.cx)(anchorStyles, active && 'active')
  }, _patternLibraryUtils.tracking.create(_name, true, false)), text));
}
FilterNavItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  text: _propTypes.default.string,
  url: _propTypes.default.string,
  active: _propTypes.default.bool,
  partial: _propTypes.default.string
};

/**
 * TemplateNavigation Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Navigation Items
 * @param {Object} props.dropdownProps Supported UXCore dropdown props
 * @returns {React.ReactElement} TemplateNavigation Component
 * @public
 */

function TemplateNavigation({
  items,
  dropdownProps
}) {
  const {
    DropdownItem
  } = _dropdown.default;
  const activeIndex = items?.findIndex(item => item.active === true);
  if (!items) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(NavContainer, {
    "data-cy": "filter-nav-container"
  }, /*#__PURE__*/_react.default.createElement(List, null, items.slice(0, 16).map((category, idx) => {
    return /*#__PURE__*/_react.default.isValidElement(category) ? /*#__PURE__*/_react.default.createElement(FilterNavItem, (0, _extends2.default)({
      value: category?.props?.value,
      key: idx
    }, category?.props)) : /*#__PURE__*/_react.default.createElement(FilterNavItem, (0, _extends2.default)({
      value: category.value,
      key: idx
    }, category));
  }))), items && /*#__PURE__*/_react.default.createElement(DropdownContainer, {
    "data-cy": "dropdown-container"
  }, /*#__PURE__*/_react.default.createElement(_dropdown.default, (0, _extends2.default)({
    id: "templates-dropdown",
    type: "select",
    name: "templates-dropdown",
    placeholder: "Select Template",
    size: "small",
    selected: [activeIndex]
  }, dropdownProps), items.map((item, i) => {
    return /*#__PURE__*/_react.default.isValidElement(item) ? /*#__PURE__*/_react.default.createElement(DropdownItem, {
      ...item?.props,
      key: i,
      href: item?.props?.url,
      ..._patternLibraryUtils.tracking.create(item?.props?.name, true, false)
    }, item?.props?.text) : /*#__PURE__*/_react.default.createElement(DropdownItem, (0, _extends2.default)({
      key: i,
      href: item.url
    }, _patternLibraryUtils.tracking.create(item._name, true, false)), item.text);
  }))));
}
var _default = exports.default = TemplateNavigation;
TemplateNavigation.propTypes = {
  items: _propTypes.default.array,
  dropdownProps: _propTypes.default.shape(_dropdown.default.propTypes)
};